import { AnalyseNonEntitledScores } from './analyse-non-entitled-scores.interface';
import { AnalyseScorecardScores } from './analyse-scorecard-flat-tree-node.interface';

export function isAnalyseScorecardNotEntitled(scores: AnalyseScorecardScores): scores is AnalyseNonEntitledScores {
  return (<AnalyseNonEntitledScores>scores).entitled === false;
}
